 <template>
  <div>
    <b-modal
      id="addPerson"
      v-model="this.showPersonEdit"
      title="Add/Edit Person Involved"
      @show="resetForm"
      scrollable
      no-close-on-backdrop
      hide-footer
      hide-header
    >
      <div>
        <ValidationObserver v-slot="{ invalid }" ref="formValidationObserver">
            <b-form @submit.prevent="doSaveInvolvedPerson">
              <b-form-group class="w-75">
                <label class="control-label">Person Type</label>
                <b-form-select v-model="eventPersonForEdit.type" class="mb-3">
                  <b-form-select-option :value=1>Involved Person</b-form-select-option>
                  <b-form-select-option :value=2>Witness</b-form-select-option>
                </b-form-select>
              </b-form-group>
              <b-form-group>
                <label class="control-label">First Name</label>
                <ValidationProvider name="First Name" rules="required" v-slot="validation">
                  <b-input
                  id="firstName"
                    class="form-control"
                    placeholder="First Name"
                    :state="spr2_getValidationState(validation)"
                    v-model="eventPersonForEdit.firstName"
                    aria-describedby="first-name-feedback"
                  />
                  <b-form-invalid-feedback id="first-name-feedback">
                    {{ validation.errors[0] }}
                  </b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
              <b-form-group>
                <label class="control-label">Last Name</label>
                <ValidationProvider name="Last Name" rules="required" v-slot="validation">
                <b-form-input
                  id="lastName"
                  class="form-control"
                  placeholder="Last Name"
                  v-model="eventPersonForEdit.lastName"
                  :state="spr2_getValidationState(validation)"
                  aria-describedby="last-name-feedback"
                />
                 <b-form-invalid-feedback id="last-name-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
              </b-form-group>
              <b-form-group>
                <label class="control-label">Address</label>
                <div class="row no-gutters">
                  <div class="col-12">
                    <b-input class="form-control" placeholder="Street Address" v-model="eventPersonForEdit.address.streetAddress1" />
                  </div>
                  <div class="col-md-6 col-8 mt-1 pr-1">
                    <b-input class="form-control" placeholder="City" v-model="eventPersonForEdit.address.city" />
                  </div>
                  <div class="col-md-3 col-4 mt-1 pr-1">
                    <b-form-input placeholder="State" v-model="eventPersonForEdit.address.state" />
                  </div>
                  <div class="col-md-3 col-6 mt-1">
                    <b-input class="form-control" placeholder="Postal Code"  v-model="eventPersonForEdit.address.postalCode"/>
                  </div>
                </div>
              </b-form-group>
              <b-form-group class="w-50">
                <label class="control-label">Primary Phone</label>
                  <ValidationProvider name="Phone Number" rules="phoneNumber" v-slot="validation">
                    <b-form-input class="form-control" v-model="eventPersonForEdit.phoneNumber" placeholder="888-888-8888"
                     name="Phone Number"
                     :state="spr2_getValidationState(validation)"
                    aria-describedby="phone-number-feedback" />
                    <b-form-invalid-feedback id="phone-number-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
              <b-form-group class="w-75">
                <label class="control-label">Email</label>
                <ValidationProvider name="Email" rules="email" v-slot="validation">
                  <b-form-input class="form-control" type="email" v-model="eventPersonForEdit.email" placeholder="name@example.com"
                    name="Email"
                    :state="spr2_getValidationState(validation)"
                    aria-describedby="email-feedback" />
                  <b-form-invalid-feedback id="email-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
              </b-form-group>
              <b-form-group>
                <label class="control-label">Affiliation</label>
                  <b-form-select v-model="eventPersonForEdit.affiliation" class="mb-3">
                    <b-form-select-option :value=0>Other</b-form-select-option>
                    <b-form-select-option :value=1>Resident</b-form-select-option>
                    <b-form-select-option :value=2>Visitor</b-form-select-option>
                    <b-form-select-option :value=3>Bystander</b-form-select-option>
                    <b-form-select-option :value=4>Employee</b-form-select-option>
                </b-form-select>
                <b-input v-if="eventPersonForEdit.affiliation === 0" class="form-control" placeholder="Other Affiliation Description"  v-model="eventPersonForEdit.otherAffiliationDescription"/>
              </b-form-group>
              <!--Display for involved person-->
              <b-form-group>
                <label class="control-label">Nature of Involvement</label>
                <b-input class="form-control" placeholder="Enter details" v-model="eventPersonForEdit.natureOfInvolvement" />
              </b-form-group>
              <!--Insurance-->
              <b-form-group>
                <label class="control-label">Insurance</label>
                <b-form-checkbox v-model="hasInsurance" switch>This person has insurance relevant to this event</b-form-checkbox>
              </b-form-group>
              <div v-if="hasInsurance && eventPersonForEdit.insurance">
                <b-form-group>
                  <label class="control-label">Insurance carrier</label>
                  <b-input class="form-control" placeholder="Insurance carrier" v-model="eventPersonForEdit.insurance.carrier" />
                </b-form-group>
                <b-form-group class="w-75">
                  <label class="control-label">Policy type</label>
                  <b-form-select v-model="eventPersonForEdit.insurance.policyType" :options="policyTypeOptions" />
                </b-form-group>
                <b-form-group v-if="!insuranceDetailsRedacted" class="w-75">
                  <label class="control-label">Policy number</label>
                  <b-input class="form-control" placeholder="Policy number" v-model="eventPersonForEdit.insurance.policyNumber" />
                </b-form-group>
                <b-form-group class="w-75">
                  <label class="control-label">Claim number (if filed)</label>
                  <b-input class="form-control" placeholder="Claim number (if filed)" v-model="eventPersonForEdit.insurance.claimNumber" />
                </b-form-group>
                <template v-if="!insuranceDetailsRedacted">
                <b-form-group>
                  <label class="control-label">Adjuster name</label>
                  <b-input class="form-control" placeholder="Adjuster name" v-model="eventPersonForEdit.insurance.adjusterName" />
                </b-form-group>
                <b-form-group class="w-50">
                  <label class="control-label">Adjuster phone</label>
                  <ValidationProvider name="Adjuster Phone" rules="phoneNumber" v-slot="validation">
                    <b-form-input class="form-control" v-model="eventPersonForEdit.insurance.adjusterPhone" placeholder="888-888-8888"
                      name="Adjuster Phone"
                      :state="spr2_getValidationState(validation)"
                      aria-describedby="adjuster-phone-feedback" />
                    <b-form-invalid-feedback id="adjuster-phone-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>
                <b-form-group class="w-75">
                  <label class="control-label">Adjuster email</label>
                  <ValidationProvider name="Adjuster Email" rules="email" v-slot="validation">
                    <b-form-input class="form-control" type="email" v-model="eventPersonForEdit.insurance.adjusterEmail" placeholder="adjuster@example.com"
                      name="Adjuster Email"
                      :state="spr2_getValidationState(validation)"
                      aria-describedby="adjuster-email-feedback" />
                    <b-form-invalid-feedback id="adjuster-email-feedback">{{ validation.errors[0] }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>
                <b-form-group>
                  <label class="control-label">Notes</label>
                  <b-form-textarea v-model="eventPersonForEdit.insurance.notes" rows="3" placeholder="Notes" />
                </b-form-group>
                </template>
                <p v-else class="small text-muted">Policy and adjuster details require insurance claim permissions.</p>
              </div>
              <b-button variant="light" @click="closePersonEditor">Close</b-button>
            <b-button type ="submit" variant="primary" :disabled="invalid">Save</b-button>
          </b-form>
        </ValidationObserver>
      </div>
    </b-modal>

    <div class="row mt-3">
      <div class="col-12 d-flex justify-content-end">
        <b-btn class="btn btn-success" @click="showNewPersonForm()">
          <i class="fas fa-plus"></i> Add Person
        </b-btn>
      </div>
    </div>
    <div class="row" v-if="involvedPeopleByType.length > 0">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <h5>Person Involved</h5>
      </div>
      <div class="col-12 pt-1">
        <b-list-group>
          <b-list-group-item v-for="involvedPerson in involvedPeopleByType" v-bind:key="involvedPerson.id">
            <div class="row">
              <div class="col-md-6 col-12">
                <p class="m-0">{{involvedPerson.firstName}} {{involvedPerson.lastName}}</p>
                <small class="text-black-50">{{ involvedPerson.address.streetAddress1 }}, {{ involvedPerson.address.city }} {{ involvedPerson.address.state }} {{ involvedPerson.address.postalCode }}</small>
              </div>
              <div class="col-md-4 col-10">
                <small class="d-block">
                  <i class="fas fa-phone-square text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.phoneNumber }}</span>
                </small>
                <small class="d-block" v-if="involvedPerson.email">
                  <i class="fas fa-envelope text-secondary"></i>&nbsp;&nbsp;
                  <a :href="'mailto:' + involvedPerson.email">{{ involvedPerson.email }}</a>
                </small>
                <small class="d-block" v-if="involvedPerson.insurance">
                  <i class="fas fa-shield-alt text-secondary"></i>&nbsp;&nbsp;
                  <span>Insurance: {{ involvedPerson.insurance.carrier || 'on file' }}<template v-if="involvedPerson.insurance.claimNumber"> · Claim #{{ involvedPerson.insurance.claimNumber }}</template></span>
                </small>
                <small class="d-block">
                  <i class="fas fa-map-marker text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.affiliation }}</span>
                </small>
                <small class="d-block">
                  <i class="fas fa-info-circle text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.natureOfInvolvement }}</span>
                </small>
              </div>
              <div class="col-md-2 col-2 text-right">
                <b-btn variant="link" @click="showEditPersonForm(involvedPerson.id)">
                  <i class="fa fa-pencil"></i>
                </b-btn>
                <b-btn
                  variant="link"
                  class="text-danger"
                  :disabled="isDeletingPerson(involvedPerson.id)"
                  @click="confirmDeletePerson(involvedPerson)"
                >
                  <i class="fa fa-trash"></i>
                </b-btn>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
    <div class="row mt-5" v-if="witnessesByType.length > 0">
      <div class="col-12 d-flex align-items-center justify-content-between" >
        <h5>Witnesses</h5>
      </div>
      <div class="col-12 pt-1">
        <b-list-group>
          <b-list-group-item v-for="involvedPerson in witnessesByType" v-bind:key="involvedPerson.id">
            <div class="row">
              <div class="col-md-6 col-12">
                <p class="m-0">{{involvedPerson.firstName}} {{involvedPerson.lastName}}</p>
                <small class="text-black-50">{{ involvedPerson.address.streetAddress1 }}, {{ involvedPerson.address.city }} {{ involvedPerson.address.state }} {{ involvedPerson.address.postalCode }}</small>
              </div>
              <div class="col-md-4 col-10">
                <small class="d-block">
                  <i class="fas fa-phone-square text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.phoneNumber }}</span>
                </small>
                <small class="d-block" v-if="involvedPerson.email">
                  <i class="fas fa-envelope text-secondary"></i>&nbsp;&nbsp;
                  <a :href="'mailto:' + involvedPerson.email">{{ involvedPerson.email }}</a>
                </small>
                <small class="d-block" v-if="involvedPerson.insurance">
                  <i class="fas fa-shield-alt text-secondary"></i>&nbsp;&nbsp;
                  <span>Insurance: {{ involvedPerson.insurance.carrier || 'on file' }}<template v-if="involvedPerson.insurance.claimNumber"> · Claim #{{ involvedPerson.insurance.claimNumber }}</template></span>
                </small>
                <small class="d-block">
                  <i class="fas fa-map-marker text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.affiliation }}</span>
                </small>
                <small class="d-block">
                  <i class="fas fa-info-circle text-secondary"></i>&nbsp;&nbsp;
                  <span>{{ involvedPerson.natureOfInvolvement }}</span>
                </small>
              </div>
              <div class="col-md-2 col-2 text-right">
                <b-btn variant="link" @click="showEditPersonForm(involvedPerson.id)">
                  <i class="fa fa-pencil"></i>
                </b-btn>
                <b-btn
                  variant="link"
                  class="text-danger"
                  :disabled="isDeletingPerson(involvedPerson.id)"
                  @click="confirmDeletePerson(involvedPerson)"
                >
                  <i class="fa fa-trash"></i>
                </b-btn>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { spr2Validation } from '../../mixins/Spr2SharedFunctions'
export default {
  mixins: [spr2Validation],
  name: 'EventPeople',
  data () {
    return {
      eventPersonForEdit: {address: {}},
      showPersonEdit: false,
      involvedPeople: [],
      deletingPersonIds: {},
      hasInsurance: false,
      insuranceDetailsRedacted: false,
      policyTypeOptions: ['', "Renter's (HO-4)", "Homeowner's", 'Auto', 'Health', "Workers' Comp", 'Commercial General Liability', 'Other']
    }
  },
  watch: {
    hasInsurance (val) {
      if (val && !this.eventPersonForEdit.insurance) {
        this.$set(this.eventPersonForEdit, 'insurance', this.emptyInsurance())
      }
    }
  },
  computed: {
    involvedPeopleByType () {
      return this.involvedPeople.filter(p => p.type === 'Involved')
    },
    witnessesByType () {
      return this.involvedPeople.filter(p => p.type === 'Witness')
    }
  },
  props: {
    eventId: null
  },
  created () {
    this.doLoadInvolvedPeople()
  },
  methods: {
    ...mapActions('events', ['getInvolvedPerson', 'saveInvolvedPerson', 'getInvolvedPeople', 'deleteInvolvedPerson']),
    resetForm () {
      console.log('resetForm called')
    },
    emptyInsurance () {
      return { carrier: '', policyType: '', policyNumber: '', claimNumber: '', adjusterName: '', adjusterPhone: '', adjusterEmail: '', notes: '' }
    },
    insuranceHasValues (insurance) {
      if (!insurance) {
        return false
      }
      return Object.keys(insurance).some(k => {
        const v = insurance[k]
        return v !== null && v !== undefined && String(v).trim() !== ''
      })
    },
    async doSaveInvolvedPerson () {
      const payload = Object.assign({}, this.eventPersonForEdit)
      const email = typeof payload.email === 'string' ? payload.email.trim() : ''
      payload.email = email === '' ? null : email
      if (this.hasInsurance) {
        payload.insurance = Object.assign({}, payload.insurance || {})
      } else {
        if (this.insuranceHasValues(payload.insurance)) {
          const confirmed = await this.$bvModal.msgBoxConfirm("Remove this person's insurance information?", {
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Remove',
            cancelTitle: 'Cancel'
          })
          if (!confirmed) {
            return
          }
        }
        payload.insurance = null
      }

      try {
        await this.saveInvolvedPerson({ eventId: this.eventId, involvedPerson: payload })
      } catch (error) {
        const message = this.getValidationErrorMessage(error)
        if (message !== null) {
          this.$toasted.error(message, { duration: 4000 })
          return
        }
        this.$toasted.error('Unable to save person. Please try again.', { duration: 4000 })
        return
      }

      this.$toasted.show('Involved Person Saved.', { duration: 3000 })
      this.showPersonEdit = false

      try {
        await this.doLoadInvolvedPeople()
      } catch (error) {
        this.$toasted.error('Person saved, but the list could not be refreshed.', { duration: 4000 })
      }
    },
    async doLoadInvolvedPeople () {
      var response = await this.getInvolvedPeople(this.eventId)
      this.involvedPeople = response.data.involvedPeople
    },
    // Returns the first field message from a 400 {errors:{field:msg}} response, else null.
    getValidationErrorMessage (error) {
      const response = error && error.response
      if (!response || response.status !== 400) {
        return null
      }
      const errors = response.data && response.data.errors
      if (!errors || typeof errors !== 'object') {
        return null
      }
      const keys = Object.keys(errors)
      for (let i = 0; i < keys.length; i++) {
        const msg = errors[keys[i]]
        const text = Array.isArray(msg) ? msg[0] : msg
        if (text !== null && text !== undefined && String(text).trim() !== '') {
          return String(text)
        }
      }
      return null
    },
    isDeletingPerson (personId) {
      return !!this.deletingPersonIds[personId]
    },
    getPersonDisplayName (person) {
      const first = person.firstName || ''
      const last = person.lastName || ''
      const fullName = `${first} ${last}`.trim()
      return fullName || 'this person'
    },
    async confirmDeletePerson (person) {
      const personName = this.getPersonDisplayName(person)
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Are you sure you want to delete '${personName}'? This action cannot be undone.`,
        {
          title: 'Confirm Delete',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          dialogClass: 'delete-person-confirm-dialog',
          contentClass: 'delete-person-confirm-content',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: false
        }
      )

      if (!confirmed) {
        return
      }

      await this.doDeletePerson(person)
    },
    async doDeletePerson (person) {
      const personId = person.id
      this.$set(this.deletingPersonIds, personId, true)

      try {
        const response = await this.deleteInvolvedPerson({ eventId: this.eventId, personId })
        const wasDeleted = response && response.data && response.data.success === true

        if (wasDeleted) {
          this.involvedPeople = this.involvedPeople.filter(p => p.id !== personId)
          this.$toasted.show('Involved Person Deleted.', { duration: 3000 })
        } else {
          this.$toasted.show('Person was not found. Refreshing list.', { duration: 3000 })
        }

        await this.doLoadInvolvedPeople()
      } catch (error) {
        this.$toasted.error('Unable to delete person. Refreshing list.', { duration: 4000 })
        await this.doLoadInvolvedPeople()
      } finally {
        this.$delete(this.deletingPersonIds, personId)
      }
    },
    initializePersonForEdit () {
      this.eventPersonForEdit = { type: 1, firstName: '', lastName: '', address: {}, email: '', insurance: null }
      this.hasInsurance = false
      this.insuranceDetailsRedacted = false
    },
    showNewPersonForm () {
      this.initializePersonForEdit()
      this.showPersonEdit = true
    },
    async showEditPersonForm (personId) {
      var response = await this.getInvolvedPerson({ eventId: this.eventId, personId: personId })
      const person = response.data.involvedPerson
      this.insuranceDetailsRedacted = response.data.insuranceDetailsRedacted === true || person.insuranceDetailsRedacted === true
      if (!person.address) {
        this.$set(person, 'address', {})
      }
      if (person.email === undefined || person.email === null) {
        this.$set(person, 'email', '')
      }
      this.hasInsurance = !!person.insurance
      if (!person.insurance) {
        this.$set(person, 'insurance', this.emptyInsurance())
      }
      this.eventPersonForEdit = person
      this.showPersonEdit = true
    },
    closePersonEditor () {
      this.showPersonEdit = false
    }
  }
}
</script>

<style>
.delete-person-confirm-content {
  height: auto !important;
  max-height: calc(100vh - 3.5rem);
}

.delete-person-confirm-content .modal-body {
  overflow-y: auto;
}
</style>
